import type { GiftCard } from '../GiftCard.types'
import { isGiftCardSingle } from './isGiftCardSingle'

export const getGiftCardTitle = (giftCard: GiftCard) => {
  if (isGiftCardSingle(giftCard)) {
    return giftCard.code
  }

  return `${giftCard.giftCards[0].code} ${giftCard.giftCards.length > 1 ? ` (+${giftCard.giftCards.length - 1})` : ''}`
}
